module.exports = __webpack_public_path__ + "img/sort.6c6a0df8.png";